import { CurrencyType } from '@wolffun/system-currency';
export let InGameCurrency;

(function (InGameCurrency) {
  InGameCurrency[InGameCurrency["INGAME_THETAN_COIN"] = CurrencyType.GTHC] = "INGAME_THETAN_COIN";
  InGameCurrency[InGameCurrency["INGAME_THETAN_GEM"] = CurrencyType.GTHG] = "INGAME_THETAN_GEM";
  InGameCurrency[InGameCurrency["INGAME_POWER_POINT"] = CurrencyType.GPP] = "INGAME_POWER_POINT";
})(InGameCurrency || (InGameCurrency = {}));

export let MainCurrency;

(function (MainCurrency) {
  MainCurrency[MainCurrency["THETAN_COIN"] = CurrencyType.THC] = "THETAN_COIN";
  MainCurrency[MainCurrency["THETAN_GEM"] = CurrencyType.THG] = "THETAN_GEM";
})(MainCurrency || (MainCurrency = {}));

export let CurrencySymbol;

(function (CurrencySymbol) {
  CurrencySymbol["INGAME_THETAN_COIN"] = "gTHC";
  CurrencySymbol["INGAME_THETAN_GEM"] = "gTHG";
  CurrencySymbol["INGAME_POWER_POINT"] = "gPP";
  CurrencySymbol["INGAME_PRIVATE_TIKCET"] = "gPT";
  CurrencySymbol["INGAME_QUEST_POINT"] = "gMQP";
})(CurrencySymbol || (CurrencySymbol = {}));